import { UsersService } from "@/Users/services";
import { FieldModel } from "@/Users/ui/form/types";

export const validateUsername = async (value: string, label: string, model: Partial<FieldModel>): Promise<string[]> => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) return [];
  const users = await UsersService.findByUsername(trimmedValue);

  if (users.length === 0) return [];
  // Check if the username is owned by the same user (current user)
  const isUsernameFromSameUser = users.some(user => user.id == model.id);
  if (isUsernameFromSameUser) return [];

  const exactMatch = users.some(user => user.username === trimmedValue);

  if (!exactMatch) return [];
  return [`${label} already exists`];
};
